/**
 * Credential age + rotation + scope warnings (backlog clearance §2).
 */

/**
 * @param {{ hasCredentials?: boolean, ageLabel?: string | null, rotationDue?: boolean, rotationPrompt?: string | null, scopeWarning?: string | null } | null | undefined} health
 */
export default function CredentialHealthStrip({ health, compact = false }) {
  if (!health?.hasCredentials) return null;

  const showRotation = Boolean(health.rotationDue && health.rotationPrompt);
  const showScope = Boolean(health.scopeWarning);

  if (!health.ageLabel && !showRotation && !showScope) return null;

  return (
    <div
      className={compact ? "space-y-1" : "space-y-1.5"}
      style={{
        fontSize: compact ? 11 : 12,
        color: "var(--text-secondary)",
        lineHeight: 1.45,
      }}
    >
      {health.ageLabel ? (
        <div>
          <span className="text-dim">Credential age: </span>
          <span className="exec-dash-mono" style={{ fontVariantNumeric: "tabular-nums" }}>
            {health.ageLabel}
          </span>
        </div>
      ) : null}
      {showRotation ? (
        <div style={{ color: "var(--warning)" }}>{health.rotationPrompt}</div>
      ) : null}
      {showScope ? (
        <div style={{ color: "var(--warning)" }}>{health.scopeWarning}</div>
      ) : null}
    </div>
  );
}
